module.exports = __webpack_public_path__ + "static/media/2.af7abcc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobileOmBoarding/2.png
// module id = 931
// module chunks = 21